export default class ParametroService {
  constructor(resource) {
    this._resource = resource;
  }

  getParametrosByChave(chaves = []) {
    const query = chaves.length > 0 ? `?chaves=${chaves.join(",")}` : "";

    return this._resource.get(`parametrosSistema${query}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os parâmetros do sistema");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/web/ParametroService.js